import apiFetch from '../../apiFetch'

export default function () {
  return apiFetch({endPoint: `admin/Empresa/index`, method: 'GET', body: null})
}
